import Table from "@/components/Table/Table";
import { usePackagingProductRelationsPerYear } from "../usePackagingMaterials";

export default function ProductRelationsPerYearTable({ materialId }: { materialId: number }) {
  const { data, isLoading, isFetching } = usePackagingProductRelationsPerYear({ materialId });
  const loading = isLoading || isFetching;

  return (
    <div>
      <Table
        loading={loading}
        type="grey"
        data={data}
        emptyState={{ hide: true }}
        hideRaster={true}
        totalRows={data ? data.length : 4}
        columns={[
          {
            label: "Year",
            key: "year",
            renderer: (record) => (!record.year ? "Unrelated" : record.year),
          },
          {
            label: "Packaging",
            key: "packaging_count",
          },
          {
            label: "Facilities",
            key: "facility_count",
          },
        ]}
        rowKey={"year"}
      />
    </div>
  );
}
